import { render } from "./ModalNegotiation.vue?vue&type=template&id=bce03950&ts=true"
import script from "./ModalNegotiation.vue?vue&type=script&lang=ts"
export * from "./ModalNegotiation.vue?vue&type=script&lang=ts"

import "./ModalNegotiation.vue?vue&type=style&index=0&id=bce03950&lang=css"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__